export default {
  showInfo () {
    this.info = true
  },
  hideInfo () {
    this.info = false
  },
  toggleModal (value) {
    this.modal = value
  },
  setCanceled () {
    this.schedule.status = 'canceled'
    this.schedule._parsed.status = 'Cancelado'
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/components/schedule/resources/methods.js